import $ from 'jquery';
import { initLpForms } from '../tracking.js';

const CLOSED_MESSAGE = '選択された日付はご希望店舗で空きがありません。別の日付を選択してください。';

$(function () {
    initLpForms();

    const $form = $('#mail_form');
    if ($form.length > 0) {
        let isSubmitting = false;
        $form.on('submit', function (e) {
            if (isSubmitting) {
                e.preventDefault();
                return;
            }
            isSubmitting = true;
            setTimeout(function () {
                $form.find(':submit').prop('disabled', true);
            }, 0);
        });
    }

    const $store = $('#store');
    if ($store.length === 0) return;

    const $days = [$('#day'), $('#day2')].filter(($el) => $el.length > 0);
    if ($days.length === 0) return;

    $days.forEach(($select) => {
        $select.data('originalOptions', $select.children().clone());
    });

    function isClosedDate(dateStr, storeCode) {
        if (!dateStr) return false;

        const [y, m, d] = dateStr.split('-').map(Number);
        const dt = new Date(y, m - 1, d);
        const weekday = dt.getDay();
        if (weekday === 0 || weekday === 1) return true;

        const holidayMap = typeof holidays !== 'undefined' ? holidays : {};
        const list = holidayMap[storeCode] || holidayMap[String(storeCode)] || [];
        return list.indexOf(dateStr) !== -1;
    }

    function refresh() {
        const storeCode = $store.val();

        $days.forEach(($select) => {
            const previousValue = $select.val();
            const $originals = $select.data('originalOptions');

            $select.empty();
            $originals.each(function () {
                const $opt = $(this).clone();
                const val = $opt.val();
                if (val && isClosedDate(val, storeCode)) return;
                $select.append($opt);
            });

            const stillExists = previousValue &&
                $select.find('option').filter(function () {
                    return $(this).val() === previousValue;
                }).length > 0;

            $select.val(stillExists ? previousValue : '');

            const $validate = $select.closest('dd').find('.validate');
            if (previousValue && !stillExists) {
                $validate.text(CLOSED_MESSAGE);
            } else {
                $validate.text('');
            }
        });
    }

    $store.on('change', refresh);
    $days.forEach(($select) => $select.on('change', refresh));
    refresh();
});
